export default function () {
  if (document.getElementById('deal-dashboard-app')) {
    import('../_03_organisms/deal-dashboard/main');
  }
}
